<template>
  <div class="animated fadeIn">
    <Forms
      ref="frmGroup"
      :title="'CADASTRO DE MOVIMENTAÇÃO'"
      :showClearButton="true"
      :showSaveButton="true"
      :showBackButton="true"
      v-on:Clear="onClear"
      v-on:Back="onBack"
      v-on:Save="onSave"
    >
      <div class="form-group row">
        <div class="col-md-6">
          <label>
            <small
              v-show="form.situacao.required"
              class="text-danger"
              >*</small
            >
            Tipo de atividade:
          </label>
          <div class="input-group pb-2">
            <b-form-group v-slot="{ reasonOption }">
              <b-form-radio-group
                v-model="form.situacao.value"
                :options="form.situacao.options"
                :aria-describedby="reasonOption"
                name="reasonOptions"
                :required="form.situacao.required"
                :state="form.situacao.state"
                stacked
              ></b-form-radio-group>
            </b-form-group>
          </div>
        </div>
        <div class="col-md-6">
          <label>
            <small
              v-show="form.codigo.required"
              class="text-danger"
              >*</small
            >
            Código:</label
          >
          <b-form-input
            v-model="form.codigo.value"
            :required="form.codigo.required"
            :state="form.codigo.state"
            placeholder="Código"
            type="number"
          />
        </div>
        <div class="input-group pb-2">
          <div class="col-md-6">
            <label>
              <small
                v-show="valorInicial.required"
                class="text-danger"
                >*</small
              >
              Valor Inicial:
            </label>
            <div class="input-group">
              <money
                placeholder="$lang.Currency.Placeholder"
                class="form-control"
                max-length="12"
                v-model="valorInicial.value"
                :required="valorInicial.required"
                v-bind="$lang.Currency.Format"
              ></money>
            </div>
          </div>
          <div class="col-md-6">
            <label>
              <small
                v-show="valorFinal.required"
                class="text-danger"
                >*</small
              >
              Valor Final:
            </label>
            <div class="input-group">
              <money
                placeholder="$lang.Currency.Placeholder"
                class="form-control"
                max-length="12"
                v-model="valorFinal.value"
                :required="valorFinal.required"
                v-bind="$lang.Currency.Format"
              ></money>
            </div>
          </div>
        </div>
        <div class="input-group pb-2">
          <div class="col-md-6">
            <label
              ><small
                v-show="form.boardId.required"
                class="text-danger"
                >*</small
              >
              Quadros:</label
            >
            <div class="input-group">
              <b-form-select
                @change="loadColumns(form.boardId.value)"
                :required="form.boardId.required"
                v-model="form.boardId.value"
                :options="form.boardId.listOptions"
                placeholder="Selecione o quadro"
                class="w-100"
                label="text"
              >
                <!-- <template v-slot:no-options>Nenhum quadro encontrado.</template> -->
              </b-form-select>
            </div>
          </div>
          <div class="col-md-6">
            <label
              ><small
                v-show="form.boardColumnId.required"
                class="text-danger"
                >*</small
              >
              Colunas:</label
            >
            <div class="input-group">
              <b-form-select
                v-model="form.boardColumnId.value"
                :required="form.boardColumnId.required"
                :options="form.boardColumnId.listOptions"
                placeholder="Selecione o quadro"
                class="w-100"
                label="text"
              >
                <!-- <template v-slot:no-options>Nenhum quadro encontrado.</template> -->
              </b-form-select>
            </div>
          </div>
        </div>
      </div>
    </Forms>
  </div>
</template>
<script>
import Tools from '@/components/tools/Tools.js'
import ActionsForm from '@/shared/mixins/actionsForm'
import { toast } from '@/shared/utils/UIHelper'

import BoardRepository from '@/shared/http/repositories/crm/board.js'
import BoardRepositoryV2 from '@/shared/http/repositories/crm/board_v2.js'

import MovimentationCarRepository from '@/shared/http/repositories/configurations/movimentationCards.js'
import MovimentationModel from '@/shared/models/configurations/movimentationmodel.js'
import MovimentationForms from './movimentationadd-form.js'

export default {
  name: 'MovimentationAdd',
  mixins: [ActionsForm],
  data () {
    return {
      data: MovimentationModel,
      form: MovimentationForms,
      valorInicial: {
        value: 0,
        required: true,
        state: null
      },
      valorFinal: {
        value: 0,
        required: true,
        state: null
      },
      nothing: 0
    }
  },
  created () {
    this.loadBoards()
    this.$nextTick(() => {
      // SEARCH FOR BOARD COLUMNS IF EDDITING
      if (this.data.boardId) this.loadColumns(this.form.boardId.value)
    })
  },
  methods: {
    onBack () {
      this.$emit('Back')
    },
    onLoad () {},
    onClear () {
      this.valorInicial.value = 0
      this.valorFinal.value = 0

      Tools.ClearDataForms(this.form, this.data)
    },
    onEdit (obj) {
      this.data.id = obj.id
      switch (obj.valorFinalDebito) {
        case null:
          // this.form.situacao.value = 'CREDITO'
          this.data.situacao = 'CREDITO'
          obj.situacao = 'CREDITO'
          this.data.valorInicial = obj.valorInicialCredito
          this.data.valorFinal = obj.valorFinalCredito

          this.valorInicial.value = obj.valorInicialCredito
          this.valorFinal.value = obj.valorFinalCredito
          break
        default:
          // this.form.situacao.value = 'DEBITO'
          this.data.situacao = 'DEBITO'
          obj.situacao = 'DEBITO'
          this.data.valorInicial = obj.valorInicialDebito
          this.data.valorFinal = obj.valorFinalDebito
          this.valorInicial.value = obj.valorInicialDebito
          this.valorFinal.value = obj.valorFinalDebito
          break
      }
      Tools.SetValueInForm(this.form, this.data, obj)
    },
    onCreate () {
      let payload = {
        codigo: this.data.codigo,
        boardId: this.data.boardId,
        boardColumnId: this.data.boardColumnId
      }

      switch (this.data.situacao) {
        case 'DEBITO':
          payload.valorFinalDebito = this.valorFinal.value
          payload.valorInicialDebito = this.valorInicial.value
          break
        case 'CREDITO':
          payload.valorFinalCredito = this.valorFinal.value
          payload.valorInicialCredito = this.valorInicial.value
          break
      }

      MovimentationCarRepository.Create(payload)
        .then((response) => {
          this.$emit('Back')
          toast.success(this.$lang.Common.Alerts.Success)
        })
        .catch(this.onException)
    },
    onUpdate () {
      let payload = {
        codigo: this.data.codigo,
        boardId: this.data.boardId,
        boardColumnId: this.data.boardColumnId,
        id: this.data.id
      }

      switch (this.data.situacao) {
        case 'DEBITO':
          payload.valorFinalDebito = this.valorFinal.value
          payload.valorInicialDebito = this.valorInicial.value
          break
        case 'CREDITO':
          payload.valorFinalCredito = this.valorFinal.value
          payload.valorInicialCredito = this.valorInicial.value
          break
      }
      MovimentationCarRepository.Update(payload)
        .then((response) => {
          this.$emit('Back')
          toast.success(this.$lang.Common.Alerts.Success)
        })
        .catch(this.onException)
    },
    loadBoards () {
      BoardRepository.Board_GetAll()
        .then((res) => {
          let activeOptions = res.data.content
            .filter((x) => x.id != null && x.arquivado !== true)
            .map((x) => ({ value: x.id, text: x.nome }))

          let filedOptions = res.data.content
            .filter((x) => x.id != null && x.arquivado === true)
            .map((x) => ({ value: x.id, text: x.nome }))

          let options = [
            {
              label: 'Quadros Ativos',
              options: activeOptions
            },
            {
              label: 'Quadros Arquivados',
              options: filedOptions
            }
          ]

          this.form.boardId.listOptions = options
        })
        .catch(this.onException)
    },
    loadColumns (boardId) {
      if (boardId) {
        BoardRepositoryV2.Column_GetAllActive(boardId)
          .then((res) => {
            let sortedContent = res.data.content.sort(
              (a, b) => a.posicao - b.posicao
            )
            let options = sortedContent
              .filter((x) => x.id != null)
              .map((x) => ({ value: x.id, text: x.nome }))
            this.form.boardColumnId.listOptions = options
          })
          .catch(this.onException)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/parametros/cardMovimentation/components/add/MovimentationAdd.vue